import userTypes from "./user.types";
import {PHARMA_TOK} from "../../helpers/general-variables";

const INITIAL_STATE={
    is_login: !!localStorage.getItem(PHARMA_TOK),
};

const userReducer= (state=INITIAL_STATE, action) => {
    switch(action.type) {

        case userTypes.LOGIN_STATUS: {
            return {
                ...state,
                is_login:action.payload
            }
        }
        default:
            return {...state}
    }
};


export default userReducer;
